import type { Routes } from '@angular/router';
import { permissionGuard } from '../../../auth/common/guards/permission.guard';

export const EMPLOYEES_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./employees-list/employees-list.component').then(
        (m) => m.EmployeesListComponent,
      ),
    canActivate: [permissionGuard('employees.get')],
  },
] as const;
